import { render, staticRenderFns } from "./ComponentDistribution.vue?vue&type=template&id=74b598a2&scoped=true&"
import script from "./ComponentDistribution.vue?vue&type=script&lang=js&"
export * from "./ComponentDistribution.vue?vue&type=script&lang=js&"
import style0 from "./ComponentDistribution.vue?vue&type=style&index=0&id=74b598a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b598a2",
  null
  
)

export default component.exports